/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { updateActivityProductsRequestSchema } from "./updateActivityProductsRequestSchema.ts";

export const updateActivityRequestSchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string().min(1),
	sizes: z.array(z.uuid()),
	products: z.array(updateActivityProductsRequestSchema),
	snapshotHash: z.string().min(1).max(64).nullish(),
});
